<template>
  <div class="l-row">
    <form-group :label="$t('brand.label')">
      <multiselect
        v-model="newItem.from.brand"
        :options="from.brands"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('brand.label')" :columns="3">
      <multiselect
        v-model="newItem.to.brand"
        :options="to.brands"
        track-by="code"
        label="label"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      newItem: {
        from: {
          brand: null
        },
        to: {
          brand: null
        }
      },
      from: {
        brands: []
      },
      to: {
        brands: []
      },
      items: [],
      alreadyExists: false,
      cloneBrands: null,
      loaderBrandsEcommerce: true,
      loaderBrandsMarketplace: true
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getBrands(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(brands => {
          this.from.brands = brands
          this.loaderBrandsEcommerce = false
          this.hideItem()
          this.$emit('loading', this.loaderBrandsEcommerce || this.loaderBrandsMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar as marcas da Moovin.', 'Erro'))

      api.gfg.getBrands()
        .then(brands => {
          this.to.brands = brands
          this.loaderBrandsMarketplace = false
          this.$emit('loading', this.loaderBrandsEcommerce || this.loaderBrandsMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar as marcas da GFG.', 'Erro'))
    },
    methods: {
      hideItem () {
        if (!this.cloneBrands) {
          this.cloneBrands = cloneDeep(this.from.brands)
        }

        this.from.brands = cloneDeep(this.cloneBrands)

        for (let i in this.preset.items) {
          const item = this.preset.items[i]

          const index = this.from.brands.indexOf(item.from.brand)
          if (index !== -1) {
            this.from.brands.splice(index, 1)
          }
        }
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            brand: this.newItem.from.brand
          },
          to: {
            brand: this.newItem.to.brand.label
          }
        }

        if (item.from.brand.toLowerCase() === item.to.brand.toLowerCase()) {
          notifier.warning('Você não precisa fazer predefinição de itens iguais.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.brand === item.from.brand &&
            itemPreset.to.brand === item.to.brand
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'active': this.preset.active,
          'item': {
            'from': this.newItem.from,
            'to': {
              'brand': this.newItem.to.brand.label
            }
          }
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      }
    },
    watch: {
      'preset.items' (value) {
        this.items = value

        this.hideItem()
      },
      'newItem.from.brand' () {
        this.emitEnabledAdd()
      },
      'newItem.to.brand' () {
        this.emitEnabledAdd()
      }
    },
    components: {
      Panel,
      FormGroup,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// BrandAddItem.vue?6b0040da